export default __webpack_public_path__ + "maps-examples-dds-circle-layer-1200-56a7c3f102a5c59d094685b832fe4749.webp";